import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAppSelector } from '../../../../../redux/hooks';
import { getUserDetails } from '../../../../../utils/orgName';
import { isElliottLessonEnabled } from '../../../../../utils/elliottFeatureFlag';
import ElliottLessonPage from './ElliottLessonPage';

/**
 * Per-org rollout gate for the Elliott conversational lesson.
 *
 * Enabled orgs get the new Elliott experience; everyone else is redirected to
 * the classic lesson page (/app/home/mentee-classic/...), which renders inside
 * the normal Layout chrome. Flip ELLIOTT_LESSON_ALL_ORGS when the content
 * backfill has covered every org.
 */
const ElliottLessonGate: React.FC = () => {
  const { levelId, taskId } = useParams<{ levelId: string; taskId: string }>();
  const orgDetails = useAppSelector((state) => state.orgDetails.data);
  // orgDetails may be unhydrated on direct navigation — the JWT org claim
  // (authId) is always available and is also allowlisted per org.
  const tokenOrgAuthId = getUserDetails().orgId;

  const enabled = isElliottLessonEnabled(orgDetails?._id, orgDetails?.authId, tokenOrgAuthId);

  if (!enabled) {
    return <Navigate to={`/app/home/mentee-classic/level/${levelId}/task/${taskId}`} replace />;
  }
  // Keyed by lesson so left-nav navigation fully remounts the page — every
  // piece of mid-lesson state (streams, draft, quiz, simulation) resets and
  // applyResume rebuilds it for the newly opened lesson.
  return <ElliottLessonPage key={`${levelId}-${taskId}`} />;
};

export default ElliottLessonGate;
